import { useTranslate } from 'hooks/useTranslations';
import { Button } from 'ui/elements/Button';
import { ProductCustomizationInput } from '__generated__/graphql';

interface CustomizeProductSwitchInterface {
  productCustomization?: ProductCustomizationInput;
  onClick(): void;
  onClear(): void;
}

// Displayed on the PDP's Product Details right menu
export const CustomizeProductSwitch = ({
  productCustomization,
  onClick,
  onClear,
}: CustomizeProductSwitchInterface) => {
  const t = useTranslate();

  return (
    <>
      {productCustomization && productCustomization.numberText ? (
        <>
          <div className="flex flex-row items-center">
            <ul>
              <li>
                {t('number')}: {productCustomization.numberText}
              </li>
              <li>
                {t('name')}: {productCustomization.nameText}
              </li>
            </ul>
            {productCustomization.imageUrl && (
              <img
                src={productCustomization.imageUrl}
                className="max-w-16"
              ></img>
            )}
          </div>
          <Button className="w-full" outlined onClick={onClear}>
            {t('clear') + ' ' + t('customization')}
          </Button>
        </>
      ) : (
        <Button className="w-full" outlined onClick={onClick}>
          {t('customize')}
        </Button>
      )}
    </>
  );
};
